import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import fetchAdverts from 'state/adverts/operations/fetchAdverts';
import { fetchThemes, fetchThemesPackages } from 'state/templates/themes/operations';
import Spinner from 'routes/template/components/Spinner';
import ThemesListTemplateComponent from './ThemesListTemplateComponent';

class ThemesListTemplate extends Component {
  componentDidMount() {
    const { themes, adverts, fetchThemes, fetchAdverts, fetchThemesPackages } = this.props;
    const requests = [];

    if (themes.length === 0) {
      requests.push(fetchThemes());
    }

    if (adverts.length === 0) {
      requests.push(fetchAdverts());
    }

    axios
      .all(requests)
      .then(() => {
        fetchThemesPackages();
      })
      .catch((error) => {
        console.error(error);
      });
  }

  render() {
    const { content, themes, packages, airlineWhitelabel } = this.props;

    if (themes.length === 0) {
      return <Spinner />;
    }

    return (
      <ThemesListTemplateComponent
        title={content.title}
        themes={themes}
        packages={packages}
        airlineWhitelabel={airlineWhitelabel}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    themes: state.templates.themes.themes,
    packages: state.templates.themes.packages,
    adverts: state.adverts.adverts,
    airlineWhitelabel: state.settings.value.airlineWhitelabel,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchAdverts() {
      return dispatch(fetchAdverts());
    },
    fetchThemes() {
      return dispatch(fetchThemes());
    },
    fetchThemesPackages() {
      return dispatch(fetchThemesPackages());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemesListTemplate);
